import mixpanel from 'mixpanel-browser';

export enum MixpanelEventName {
  pageView = 'pageview',
  engagementsListClick = 'ae_engagement-list_engagement-link_click',
  downloadFile = 'ae_client-file-downloads_downloaded-file',
  createTask = 'ae_engagement-details_add-task_click',
  createEngagement = 'ae_engagement-add-engagement_click',
  renewalsListClick = 'ae_renewals-list_renewals-link_click ',
  // TODO: Replace with downloadFIle
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  renewalsFileDownload = 'ae_client-file-downloads_downloaded-file',
  leadListClick = 'ae_leads-list_lead-link_click',
  leadFileDownload = 'ae_client-leads-downloads_downloaded-file',
  portalAdvisorNotificationCenterClick = 'portal_advisor-notification-center_click',
  portalAdvisorNotificationClick = 'portal_advisor-notification_click',
  fileUploadTagChange = 'portal_file-uploads_edit-category',
  fileUploadsUploadClick = 'ae_file-uploads_upload-click',
  fileUploadsUploadedFile = 'ae_file-uploads_uploaded-file',
  moveFiles = 'ae-client-files_move-file',
  authFormModalKbaChange = 'ae_task_kba_click',
  taskSentToClientClick = 'ae_engagement-details_task-sent-to-client_click',
  sendFinalInvoiceClick = 'ae_invoices_send-final-invoice',
  viewOrEditFinalInvoiceClick = 'ae_invoices_view-edit-final-invoice',
}

const hasProjectToken = (): boolean =>
  !!import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN;

const initialize = (): void => {
  if (!hasProjectToken()) {
    return;
  }
  const proxyDomain = import.meta.env.VITE_MIXPANEL_PROXY_DOMAIN;
  const projectToken = import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN;

  const mixpanelConfig = proxyDomain
    ? {
        api_host: `https://${proxyDomain}`,
      }
    : {};

  mixpanel.init(projectToken, mixpanelConfig);
};

const identify = (userPid: string): void => {
  if (!hasProjectToken()) {
    return;
  }

  mixpanel.identify(userPid);
};

const track = (
  eventName: MixpanelEventName,
  properties: { [key: string]: any },
): void => {
  // @ts-ignore
  if (import.meta.env.MODE !== 'production') {
    console.log('Tracking', eventName, properties);
  }

  if (!hasProjectToken()) {
    return;
  }

  mixpanel.track(eventName, properties);
};

export const MixpanelUtils = { initialize, identify, track, hasProjectToken };
